import { Fragment, useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import useFetchData from '../../../../helpers/useFetch';
import AppURL from '../../../../constants/AppURL';
import { VoucherContext } from '../../../../context/VoucherEntryContext';
import HeaderFormView from './widgets/HeaderFormView';
import DebitCreditBankView from './widgets/DebitCreditBankView';
import VoucherEntryListView from './widgets/VoucherEntryListView';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import FullLedgersView from './widgets/ledgers/FullLedgersView';

const VoucherEntryFormView = () => {
    const { data, loading, error } = useFetchData(`${AppURL.AccountURL}account/general/ledger/options/list/view/`);
    const context = useContext(VoucherContext);
    const { ContraVoucherAccountList } = useSelector((state: RootState) => state.accounts);
    if (!context) {
        return <Typography>Error: Context not available</Typography>;
    }
    const { values, setFieldValue, ResetForm, handleChange, handleBlur, touched, errors } = context;
    if (loading) {
        return <Typography>Loading...</Typography>;
    }
    if (error) {
        return <Typography color="error">Error: {error}</Typography>;
    }
    let tableData;
    if (values.voucher_type === "1") {
        tableData = data?.type1Data || [
            {
                sn: 1,
                date_ne: values.date_en,
                particular_name: values.particular_name || "",
                debitamt: values.debitamt,
                creditamt: values.creditamt,
            }
        ];
    } else if (values.voucher_type === "2") {
        tableData = ContraVoucherAccountList || []; // Replace with actual data structure
    } else {
        tableData = [];
    }

    return (
        <Grid container spacing={1}>
            <Grid item lg={12} md={12} xs={12} xl={12} sm={12}>
                <HeaderFormView data={data} loading={loading} context={context} />
            </Grid>
            {
                values.view_full_leader ? <Grid item lg={12} md={12} xs={12} xl={12} sm={12}><FullLedgersView /></Grid> : <Fragment>
                    <Grid item lg={8} md={8} xs={12} xl={8} sm={12}>
                        <DebitCreditBankView context={context} />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12} xl={4} sm={12}>
                        <VoucherEntryListView data={tableData} />
                    </Grid>
                </Fragment>
            }
        </Grid>
    );
};

export default VoucherEntryFormView;
